module.exports = __webpack_public_path__ + "static/media/landing-carsafe.4a766add.png";